import * as actions from '../actions/bookmark.action.js';
import {default_state} from './index.js';
import {MODEL_LOAD} from '../actions/model.action.js';

export function bookmark_tab(state=default_state.bookmark_tab, action={}, full_state={}){
    let bookmark_tab = action.bookmark_tab || {};
    let default_bookmark_state = default_state.bookmark_tab;

    function getBookmarkStatus(problemIdentifier) {
      let bookmarkStatus = {
        isBookmarked: false
      }

      if(!problemIdentifier) {
        return bookmarkStatus;
      }

      let toc = full_state.toc;
      let chapterId = toc.problems[problemIdentifier].chapter;
      let problems = toc.chapters[chapterId].problems;

      for(let i = 0; i < problems.length; i++) {
        if(problems[i].identifier == problemIdentifier) {
          bookmarkStatus.isBookmarked = problems[i].isBookmarked;
          break;
        }
      }

      return bookmarkStatus;
    }

    switch (action.type) {
        case actions.OPEN_BOOKMARK_STATUS:
            return {
                ...default_bookmark_state
            };

        case actions.BOOKMARK_STATUS_DOWNLOADED:
            let problem_identifier = action.problem_identifier ? action.problem_identifier : full_state.problem.identifier;
            let bookmark_tab = getBookmarkStatus(problem_identifier);

            return {
                ...state,
                ...bookmark_tab
            };

        case actions.BOOKMARK_COUNT_DOWNLOADED:
            let bookmark_count = action.bookmark_count;

            return {
                ...state,
                count: bookmark_count
            };

        case actions.POST_BOOKMARK:
        {
          let bookmarkData = action.bookmarkData;
            return {
                ...state,
                isBookmarked: !bookmarkData.isBookmarked
            };
        }

        case actions.POST_BOOKMARK_ERROR:
        {
            return {
                ...state,
                isBookmarked: !state.isBookmarked
            };
        }
    }

    return state;
}



// WEBPACK FOOTER //
// ./src/reducers/bookmark.reducer.js